import React from 'react'
import PropTypes from 'prop-types'
import Titlebar from 'core/components/Titlebar'

const FullscreenWindow = (props) => {
  return (
    <div className="window mod-fullscreen">
      <div className="window-wrapper">
        {props.titlebar && <Titlebar {...props.titlebar} />}
        <div className="window-content">
          {props.loading ? <div className="window-loading">Loading...</div> : props.children}
        </div>
      </div>
    </div>
  )
}

FullscreenWindow.propTypes = {
  titlebar: PropTypes.object
}

export default FullscreenWindow
